
import { SearchCriteria } from "./search-criteria";

export class GroupSearchCriteria extends SearchCriteria {

  public Ids: number[];

}

